<template>
  <div class="card-style-gate">
    <div class="g-title">{{ payload.reason || '产品认对了吗？风格和页数就这么定？' }}</div>

    <!-- ★产品档案（只读）—— 这是整条链的事实锚点：
         category 进生图 prompt、visibleText 决定文案能不能写数字。
         认错了后面文案和底图全跟着错，所以摆出来让人核一眼 -->
    <div class="profile">
      <div class="p-row"><span class="k">认出来是</span><b>{{ profile.category }}</b></div>
      <div v-if="profile.brand" class="p-row"><span class="k">品牌</span>{{ profile.brand }}</div>
      <div class="p-row"><span class="k">外观</span><span class="v">{{ profile.appearance }}</span></div>
      <div v-if="visibleText" class="p-row"><span class="k">图上读到</span>{{ visibleText }}</div>
      <div class="p-tip">认错了的话，先取消换张更清楚的图 —— 后面的文案和配图都基于这个判断</div>
    </div>

    <!-- 风格 -->
    <div class="sec-label">风格</div>
    <div v-if="payload.pickReason" class="pick-reason">AI 选了「{{ styleName(payload.setId) }}」：{{ payload.pickReason }}</div>
    <div class="styles">
      <div
        v-for="o in payload.options"
        :key="o.id"
        class="chip"
        :class="{ on: chosenSet === o.id }"
        :title="desc(o.id)"
        @click="chosenSet = o.id"
      >
        {{ styleName(o.id) }}
        <span class="range">{{ o.min }}~{{ o.max }}页</span>
      </div>
    </div>

    <!-- 页数 -->
    <div class="sec-label">
      出几页
      <span v-if="payload.clamped" class="clamped">（你要的页数超出这个风格的能力，已自动调整）</span>
    </div>
    <div class="pages">
      <div
        v-for="n in pageChoices"
        :key="n"
        class="chip small"
        :class="{ on: chosenPages === n }"
        @click="chosenPages = n"
      >{{ n }}</div>
    </div>

    <div class="btns">
      <el-button type="primary" size="small" :loading="submitting" @click="confirm">就这么定</el-button>
      <el-button size="small" :disabled="submitting" @click="$emit('cancel')">先不弄了</el-button>
      <span v-if="dirty" class="changed">已改动，确认后会按新选择重出文案</span>
    </div>
  </div>
</template>

<script>
import { styleName, STYLE_DESC } from '../constants'

export default {
  name: 'CardStyleGate',
  props: {
    payload: { type: Object, required: true },
    submitting: { type: Boolean, default: false },
  },
  data() {
    return {
      chosenSet: this.payload.setId,
      chosenPages: this.payload.totalPages,
    }
  },
  computed: {
    profile() {
      return this.payload.profile || {}
    },
    visibleText() {
      return (this.profile.visibleText || []).join('、')
    },
    /** 当前风格能出的页数区间 —— 换风格时跟着变，别让用户选到出不来的张数 */
    pageChoices() {
      const o = (this.payload.options || []).find((x) => x.id === this.chosenSet)
      if (!o) return [3, 4, 5, 6]
      const out = []
      for (let i = o.min; i <= o.max; i++) out.push(i)
      return out
    },
    dirty() {
      return this.chosenSet !== this.payload.setId || this.chosenPages !== this.payload.totalPages
    },
  },
  watch: {
    // 换风格后如果原来的页数超出新风格能力，夹回区间内
    chosenSet() {
      const c = this.pageChoices
      if (!c.includes(this.chosenPages)) this.chosenPages = c[0]
    },
  },
  methods: {
    styleName,
    desc(id) {
      return STYLE_DESC[id] || ''
    },
    confirm() {
      // ★没改就是 approve；改了才发 change —— 两者在后端走不同分支
      //   （change 会把用户指定的风格直接定死，不再问 AI）
      if (!this.dirty) {
        this.$emit('submit', { action: 'approve' })
      } else {
        this.$emit('submit', { action: 'change', setId: this.chosenSet, totalPages: this.chosenPages })
      }
    },
  },
}
</script>

<style lang="scss">
.card-style-gate {
  .g-title { font-size: 14px; font-weight: 600; color: #1f2329; }

  .profile {
    margin-top: 10px; padding: 12px 14px;
    background: rgba(255, 255, 255, 0.72); border-radius: 8px;
    .p-row { font-size: 13px; color: #1f2329; line-height: 1.9; }
    .k { display: inline-block; width: 64px; color: #8a8f98; font-size: 12px; }
    .v { color: #4e5462; }
    .p-tip { margin-top: 6px; font-size: 12px; color: #a0a4ab; }
  }

  .sec-label { margin-top: 14px; font-size: 13px; color: #1f2329; font-weight: 500; }
  .clamped { font-size: 12px; color: #f0a020; font-weight: 400; }
  .pick-reason { margin-top: 4px; font-size: 12px; color: #8a8f98; line-height: 1.6; }

  .styles, .pages { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 8px; }
  .chip {
    padding: 6px 12px; border: 1px solid #dcdfe6; border-radius: 16px;
    font-size: 13px; color: #606266; cursor: pointer; background: #fff;
    &:hover { border-color: #4b7bff; color: #4b7bff; }
    &.on { border-color: #4b7bff; color: #fff; background: #4b7bff; }
    .range { margin-left: 5px; font-size: 11px; opacity: .7; }
  }
  .chip.small { padding: 5px 14px; }

  .btns { margin-top: 16px; display: flex; align-items: center; gap: 8px; }
  .changed { font-size: 12px; color: #f0a020; }
}
</style>
